// extracted by mini-css-extract-plugin
module.exports = {"frame":"EmbedFrame_frame__muzWd","wrapper":"EmbedFrame_wrapper__Tzy92"};